import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation } from "react-router-dom";
import "../styles/services.css";
import s1 from "../assets/images/s1.png";
import s2 from "../assets/images/s2.png";
import s3 from "../assets/images/s3.png";
import s4 from "../assets/images/s4.jpg";
import s5 from "../assets/images/s5.jpg";
import s6 from "../assets/images/s6.jpg";
import s7 from "../assets/images/s7.png";
import s8 from "../assets/images/s8.png";
import s9 from "../assets/images/s9.png";
import s10 from "../assets/images/s10.png";
import s11 from "../assets/images/s11.png";
import s12 from "../assets/images/s12.png";

const Services = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sectionsData = useMemo(() => [
    {
      id: "digital-transformation",
      title: "Digital Transformation",
      img: s1,
      content: [
        "Adopting digital technology can bring various benefits to a business. CIPS has also observed that digital capability can be used to support supply chain transparency and remote working.",
        "The goal for its implementation is to increase value through innovation, invention, improved customer experience and efficiency",
        "Focusing on efficiency and costs, the Chartered Institute of Procurement & Supply (CIPS) defines “digitalisation” as the practice of redefining models, functions, operations, processes and activities by leveraging technological advancements",
        "to build an efficient digital business environment – one where gains (operational and financial) are maximised, and costs and risks are minimised"
      ]
    },
    {
      id: "business-intelligence",
      title: "Business Intelligence",
      img: s2,
      content: [
        "BI is a technology-driven process for analyzing data and delivering actionable information that helps executives, managers and workers make informed business decisions.",
        "The Goal of BI is to help inform and improve business decision-making by making data easier to interpret and act on. BI involves collecting and visualizing data, AI & Emerging Technology Customer Experience and Loyalty Customer Analytics"
      ]
    },
    {
      id: "analytics-data-science",
      title: "Analytics and Data Science",
      img: s3,
      content: [
        "Data science is an umbrella term for all aspects of data processing—from the collection to modelling to insights. On the other hand, data analytics is mainly concerned with statistics, mathematics, and statistical analysis.",
        "The Goal is implementation of statistical methods and machine learning algorithms to analyse complex data sets and identify insights that can drive strategies"
      ]
    },
    {
      id: "cybersecurity",
      title: "Cybersecurity/Information Security",
      img: s4,
      content: [
        "In today’s hyper-connected world, the importance of strong cybersecurity and information security cannot be overstated. As cyber threats become more sophisticated, businesses face growing risks to their data, infrastructure, and reputation.",
        "We provide comprehensive cybersecurity solutions that address these risks head-on. Our approach includes advanced threat detection, secure data management, and robust risk mitigation strategies.",
        "We work proactively to ensure that your organization is compliant with the latest regulations and standards, reducing vulnerabilities while fostering trust with customers and partners.",
        "Our services help you navigate the complexities of modern cyber threats, protecting your assets and ensuring the continuity of your operations in a secure, resilient environment."
      ]
    },
    {
      id: "ai-tech",
      title: "AI & Emerging Technology",
      img: s5,
      content: [
        "AI and Emerging Technologies are at the heart of the digital transformation reshaping industries worldwide.",
        "We harness the power of artificial intelligence, machine learning, and robotics to create intelligent systems that not only automate routine tasks but also enable complex problem-solving.",
        "These technologies drive operational efficiency, optimize workflows, and unlock new opportunities for innovation.",
        "From intelligent automation to predictive systems, our AI solutions are designed to meet the specific needs of your industry, helping you stay ahead in a fast-paced digital landscape."
      ]
    },
    {
      id: "customer-analytics",
      title: "Customer Analytics",
      img: s6,
      content: [
        "Understanding and predicting customer behavior is critical for any business aiming to thrive in today’s competitive landscape.",
        "Our Customer Analytics services delve deep into the data generated by customer interactions, transactions, and feedback, providing a comprehensive view of their preferences, needs, and patterns.",
        "By analyzing this data, we enable businesses to make informed decisions that enhance the customer experience, improve retention, and drive revenue growth.",
        "With real-time insights and predictive capabilities, we help you build stronger customer relationships, tailor your strategies to market demands, and achieve measurable results that boost customer loyalty and satisfaction."
      ]
    },
    {
      id: "data-management",
      title: "Data Management Modelling and Mining",
      img: s7,
      content: [
        "Data mining is the process of sorting through large data sets to identify patterns and relationships that can help solve business problems through data analysis.",
        "We are using Data mining techniques and tools to help enterprises predict future trends and make more informed business decisions."
      ]
    },
    {
      id: "innovation",
      title: "Innovation and Data Architects and Scientist",
      img: s8,
      content: [
        "Innovation is the cornerstone of progress, and data is the foundation upon which future-focused businesses are built.",
        "Our team of Data Architects and Scientists are experts at designing and implementing sophisticated data systems that empower businesses to unlock the full potential of their information.",
        "By applying innovative data science techniques, we turn raw data into actionable insights, guiding smarter decision-making and strategic planning.",
        "Whether it’s predictive modeling, algorithm development, or data visualization, our solutions help businesses innovate faster and leverage data as a powerful asset for long-term success."
      ]
    },
    {
      id: "operational-tech",
      title: "Operational Technology",
      img: s9,
      content: [
        "Operational technology can be found in warehouses, parking lots, highways, and public transportation.",
        "We provide services to track transactions of these systems and produce dashboards to help enterprises improve efficiency and business performance."
      ]
    },
    {
      id: "it-compliance",
      title: "IT Compliance Risk and Governance",
      img: s10,
      content: [
        "Focus and Scope: IT governance orchestrates IT’s strategic direction and performance within an organization, while IT compliance concentrates on adhering to specific external regulations pertinent to the industry.",
        "Objectives: IT governance aims to optimize IT resources and performance, creating value. In contrast, IT compliance strives for adherence to external standards to avert legal and financial ramifications.",
        "Time Frame: IT governance adopts a long-term outlook, aligning IT with organizational goals, whereas IT compliance often targets immediate, short-term regulatory compliance.",
        "Flexibility: IT governance allows more adaptability to shifting organizational needs, whereas IT compliance demands strict adherence to set regulations."
      ]
    },
    {
      id: "intelligent-info",
      title: "Intelligent Information/RPA",
      img: s11,
      content: [
        "Intelligent Information/RPA is an automation solution where expert to citizen developers can build intelligent bots to automate repetitive manual processes.",
        "IPA should increase operational efficiency, worker performance and response efficiency to customers.",
        "RPA is a solution to automate day-to-day manual tasks such as data entry, test data creation, and report generation."
      ]
    },
    {
      id: "e-gov-iot",
      title: "E-gov/Iot/IIoT",
      img: s12,
      content: [
        "The integration of IoT in e-government can transform public services by enabling real-time data-driven solutions.",
        "Smart devices enhance government applications across healthcare, transportation, security, and smart cities.",
        "Despite its potential, IoT adoption in e-government faces technical, organizational, political, and legal challenges.",
        "IoT can improve public safety and efficiency, but a comprehensive framework is needed to maximize its benefits in administration."
      ]
    }
  ], []);

  const [activeSection, setActiveSection] = useState(null);

  const location = useLocation();

  // When navigated here from footer with a target section, activate it
useEffect(() => {
    const target =
      location.state?.scrollToSection ||
      (location.hash ? location.hash.replace('#', '') : null);

    if (target && sectionsData.some(s => s.id === target)) {
      setActiveSection(target);
    }
  }, [location.state, location.hash, sectionsData]);

  useEffect(() => {
  if (!activeSection) return;

  const sectionEl = document.getElementById(activeSection);

  if (sectionEl) {
      const y =
      sectionEl.getBoundingClientRect().top +
      window.pageYOffset -
      120; // Navbar height

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
}, [activeSection]);

  return (
    <div>
      <section className="hero-banner">
        <div className="hero-overlay"></div>
        <div className="hero-header">
          <h1>Services</h1>
          <p><Link to="/home">Home</Link> » <span>Services</span></p>
        </div>
      </section>

      <div className="content-wrapper">
        <aside className="services-sidebar">
          <ul>
            {sectionsData.map(section => (
              <li
                key={section.id}
                className={activeSection === section.id ? "active-link" : ""}
                onClick={() => setActiveSection(section.id)}
              >
                {section.title || section.id.replace(/-/g, ' ')}
              </li>
            ))}
          </ul>
        </aside>

        <main className="services-content">
          {sectionsData.map(section => (
            <section
              key={section.id}
              id={section.id}
              className={`service-section ${activeSection === section.id ? "active-section" : ""}`}
            >
              <img src={section.img} alt={section.title || section.id} />
              {section.title && <h1>{section.title}</h1>}
              {section.content.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </section>
          ))}
        </main>
      </div>
    </div>
  );
};


export default Services;
